export default __webpack_public_path__ + "static/media/logo.428fb7cc.png";